<!-- 1模板:html结构 -->
<template>
  <div id="app">
    <ul>
      <li>
        <router-link to="/">Home</router-link>
      </li>
      <li>
        <router-link to="/helloworld">hello</router-link>
      </li>
    </ul>
    <router-view></router-view>
  </div>
</template>

<!-- 2行为:逻辑处理 -->
<script>
  // 局部注册组件


  export default {
    name: 'App',
    data() {
      return {}
    }
  }
</script>

<!-- 3样式:解决样式 -->
<style scoped>
  h1 {
    color: purple;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue